const initialState = { instances: [] };

export default (state = initialState, action) => {
  
  switch (action.type){
        case 'REQUEST_INSTANCES':
          return {
            ...state
          };
          case 'RECEIVE_INSTANCES':
            return {
              ...state,
              instances: action.instances
            };
        case 'ADD_INSTANCE':
            const instances = [...state.instances, action.instance] 
            return {...state, instances} 
        case 'REMOVE_INSTANCE': {
            const instances = state.instances.filter(({id}) => {
              return id !== action.id;
            });
            return {...state, instances};
          }
        case 'EDIT_INSTANCE': 
            const i =  state.instances.map((instance) => {
                if(instance.id === action.id){
                    return {
                      ...instance, 
                      ...action.updates
                    }
                }else{
                    return instance;
                }
            });
            return {
              ...state,
              instances: i
            };
        case 'RECEIVE_LAST_REGISTERS':
            return{
              ...state
            };
        default: 
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/instances.js